<template>
    <rkm-modal
        :loading="loading"
        :title="`Transferência (${transferencia.dataTransferencia})`"
        extra-large
        ref="Modal"
    >
        <Form
            :id="transferencia.id"
            @save="handleSave"
            ref="Form"
        />

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>

            <template v-if="!transferencia.confirmado && !transferencia.recusado">
                <rkm-button
                    :disabled="!!loading"
                    @click="$refs.Form.reject()"
                    color="danger"
                >
                    Recusar
                </rkm-button>

                <rkm-button
                    :disabled="!!loading"
                    @click="$refs.Form.accept()"
                    color="success"
                >
                    Aceitar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        transferencia: {},
    }),
    methods: {
        open(transferencia) {

            this.transferencia = transferencia

            this.$refs.Modal.show()
        },
        handleSave() {

            this.$refs.Modal.hide()
            this.$emit('save')
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
    }
}
</script>